import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async store(catalogId: number, influencers: string, category: number): Promise<any> {
    return await this.call(`/spa/catalogs/${catalogId}/approaches`, {
      method: 'post',
      body: { influencers, category },
    })
  }

  async batchStore(catalogId: number, approachIds: number[]): Promise<any> {
    return await this.call(`/spa/catalogs/${catalogId}/approaches/batch`, {
      method: 'post',
      body: {
        approaches: approachIds,
      },
    })
  }

  async batchDelete(catalogId: number, approachIds: number[]): Promise<any> {
    return await this.call(`/spa/catalogs/${catalogId}/approaches/batch`, {
      method: 'delete',
      body: {
        approaches: approachIds,
      },
    })
  }

  async batchMove(fromCatalogId: number, toCatalogId: number, approachIds: number[]): Promise<any> {
    return await this.call(`/spa/catalogs/${fromCatalogId}/approaches/move/${toCatalogId}`, {
      method: 'post',
      body: {
        approaches: approachIds,
      },
    })
  }
}
